namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;

	export interface ITask {
		id: number;
		closedBy: number;
		createdBy: number;
		createdDate: string | Date;
		updatedBy: number;
		updatedDate: string | Date;
		typeCategory: number;
		typeCode: string;
		typeDescription: string;
		conditions: any[];
		accountId: number;
		caseId: number;
		assignedUserId: number;
		dueDate: string | Date;
		completionDate: string | Date;
		isCompleted: boolean;
		resolution: string;
		documentId: number;
		typeId: number;
		subject: string;
		body: string;
	}

	export class Task implements ITask {
		id: number;
		closedBy: number;
		createdBy: number;
		createdDate: string | Date;
		updatedBy: number;
		updatedDate: string | Date;
		typeCategory: number;
		typeCode: string;
		typeDescription: string;
		conditions: any[];
		accountId: number;
		caseId: number;
		assignedUserId: number;
		dueDate: string | Date;
		completionDate: string | Date;
		isCompleted: boolean;
		resolution: string;
		documentId: number;
		typeId: number;
		subject: string;
		body: string;

        constructor(obj?: ITask | any) {
            this.id = null;
			this.closedBy = null;
			this.createdBy = null;
			this.createdDate = null;
			this.updatedBy = null;
			this.updatedDate = null;
			this.typeCategory = null;
			this.typeCode = '';
			this.typeDescription = '';
			this.conditions = [];
			this.accountId = null;
			this.caseId = null;
			this.assignedUserId = null;
			this.dueDate = null;
			this.completionDate = null;
			this.isCompleted = null;
			this.resolution = '';
			this.documentId = null;
			this.typeId = null;
			this.subject = '';
			this.body = '';

            if (obj) {
				this.id = obj.id || null;
				this.closedBy = obj.closedBy || null;
				this.createdBy = obj.createdBy || null;
				this.createdDate = obj.createdDate || null;
				this.updatedBy = obj.updatedBy || null;
				this.updatedDate = obj.updatedDate || null;
				this.typeCategory = obj.typeCategory || null;
				this.typeCode = obj.typeCode || '';
				this.typeDescription = obj.typeDescription || '';

				if (obj.conditions) {
					for (const condition of obj.conditions) {
						this.conditions.push(condition);
					}
				}

				this.accountId = obj.accountId || null;
				this.caseId = obj.caseId || null;
				this.assignedUserId = obj.assignedUserId || null;
				this.dueDate = obj.dueDate || null;
				this.completionDate = obj.completionDate || null;
				this.isCompleted = obj.isCompleted || null;
				this.resolution = obj.resolution || '';
				this.documentId = obj.documentId || null;
				this.typeId = obj.typeId || null;
				this.subject = obj.subject ||  '';
				this.body = obj.body || '';
            }
        }
    }
}